import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import { Header } from 'semantic-ui-react';
import withFixedColumns from 'react-table-hoc-fixed-columns';
import ReactTable from 'react-table';

import { Separator, Row, Button } from '@cuemath/comps';

import { FORM_ACTIONS, MODAL_FORM, teacherCredStateOptions } from 'constants/form';
import MODAL from 'constants/modal';
import { HeaderHead } from 'modules/form';
import { IconButton } from 'modules/list';
import { openModal } from 'actions/modal';
import EditIcon from 'img/edit.png';
import { epochToDate } from 'utils';

import 'react-table/react-table.css';
import 'react-table-hoc-fixed-columns/lib/styles.css';

const HeaderHeadWrapper = styled(HeaderHead)`
  padding: 10px;
`;
const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  padding-left: 20px;
  padding-right: 20px;
`;
export const Footer = styled.div`
  margin-left: 20px;
`;

const ReactTableFixedColumns = withFixedColumns(ReactTable);

class TeacherCredsForm extends PureComponent {
  static defaultProps = {
    teacher: null,
  };
  static propTypes = {
    teacher: PropTypes.object,
    userConfig: PropTypes.object.isRequired,
  };

  renderFormHeader = () => {
    const { teacher } = this.props;

    if (!teacher) return;
    return (
      <HeaderHeadWrapper>
        <Header as="h3">Teacher Creds</Header>
      </HeaderHeadWrapper>
    );
  };

  openTeacherCredForm = ({ formType, data }) => {
    const { actions } = this.props;
    actions.openModal(
      MODAL_FORM.TEACHER_CRED_FORM,
      {
        size: 'custom',
        width: `${Math.ceil((window.innerWidth * 60) / 100)}px`,
        height: MODAL.HEIGHT,
      },
      { formType, data },
    );
  };

  renderFormRows = () => {
    const { teacher: { creds = [] } = {} } = this.props;

    const columnsData = [
      {
        Header: 'Name',
        accessor: 'cred_name',
      },
      {
        Header: 'Status',
        accessor: 'status',
        Cell: ({ value }) =>
          teacherCredStateOptions.filter(element => element.value === value)[0].label,
      },
      {
        Header: 'State Changed On',
        accessor: 'updated_on',
        Cell: ({ value }) => (value ? epochToDate(value, 'DD-MM-YYYY') : ''),
      },
      {
        Header: 'Is Primary',
        accessor: 'is_primary',
        Cell: ({ value }) => (value ? 'True' : 'False'),
      },
      {
        Header: 'Action',
        accessor: 'action',
        Cell: row => (
          <Row justifyContent="space-around">
            <IconButton
              icon={EditIcon}
              onClick={() => {
                this.openTeacherCredForm({
                  formType: FORM_ACTIONS.EDIT,
                  data: row.original,
                });
              }}
            />
          </Row>
        ),
      },
    ];

    const tableColumns = [
      {
        Header: ``,
        columns: columnsData,
      },
    ];

    return (
      <TableWrapper>
        <ReactTableFixedColumns
          data={creds}
          className="-striped -highlight"
          manual
          showPaginationTop
          showPageSizeOptions={false}
          filterable={false}
          sortable={false}
          resizable={false}
          defaultPageSize={5}
          defaultFilterMethod={(filter, row) => String(row[filter.id]) === filter.value}
          columns={tableColumns}
          style={{ height: 200, textAlign: 'center' }}
        />
      </TableWrapper>
    );
  };

  renderExtraRowsFooter = () => {
    const {
      teacher: { id: teacherId },
    } = this.props;
    return (
      <Footer>
        <Button
          label="Add Teacher Cred"
          floated="left"
          onClick={() => {
            this.openTeacherCredForm({
              formType: FORM_ACTIONS.CREATE,
              data: { teacher_id: teacherId },
            });
          }}
        />
      </Footer>
    );
  };

  render() {
    return (
      <React.Fragment>
        {this.renderFormHeader()}
        <Separator transparent height="25" />
        {this.renderFormRows()}
        <Separator transparent height="50" />
        {this.renderExtraRowsFooter()}
      </React.Fragment>
    );
  }
}

export default connect(
  ({}) => ({}),
  dispatch => ({
    actions: bindActionCreators(
      {
        openModal,
      },
      dispatch,
    ),
  }),
)(TeacherCredsForm);
